module.exports = "./assets/assets/招标公示模板.c561f3a3.docx";